import React from "react"
import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import FastTextArea from '../util/FastTextArea';
import FastFormQuestion from "../util/FastFormQuestion";
import FORM_QUESTIONS from '../../step4_questions.json';

export default function DataAnalysisDialog(props) {
    
    const handleClose = () => {
        props.handleCloseDialog()
    }

    const handleCancel = () => {
        props.handleCancelDialog()
    }
    
    const incompleteStepsExist = (programId) => {
        if (programId) {
            if (props.step1CompletionData[programId] &&
                !props.step1CompletionData[programId].completed) {
                return true
            }

            if (props.step2CompletionData[programId] &&
                !props.step2CompletionData[programId].completed) {
                return true
            }

            if (props.step3CompletionData[programId] &&
                !props.step3CompletionData[programId].completed) {
                return true
            }
        }
        return false
    }

    const isFormDisabled = (programId) => {
        if (incompleteStepsExist(programId)) {
            return true
        }

        if (programId) {
            if (props.stepCompletionData && programId in props.stepCompletionData) {
                if (props.stepCompletionData[programId].completed == undefined) {
                    return false
                } else {
                    return props.stepCompletionData[programId].completed
                }
            } else {
                // no completion data found for programId
                // indicating step is incomplete.
                // Allow user to complete form.
                return false
            }
        }
        return true
    }
    
    let programId = props.selectedProgram?.programId
    let sloId = props.selectedLearningOutcome?.sloId

    let step2Data = {
        summaryOfResults: "",
        reflectionOnHypothesis: "",
        interpretationOfResults: "",
        followUpQuestions: "",
        actionsForImprovement: "",
    }
    
    if (programId in props.step2DataStore) {
        let step2DataByProgram = props.step2DataStore[programId]
        if (sloId in step2DataByProgram) {
            step2Data = step2DataByProgram[sloId]
        }
    }
    
    return (
        <Modal size="lg" show={props.showModal} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Data Analysis - Edit</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="text-center">
                    <h2>Data Analysis - Round 1</h2>
                    <div className="p-3">
                        Use the boxes below to describe the analysis performed on the 
                        data collected for each current learning outcome (and gen ed 
                        essential skill). Please review background information about 
                        Analyzing Assessment Data before continuing: <a href="https://rise.articulate.com/share/FnW6jBaKdsAvn-k5GnSigw6uRGayAGsl#/lessons/qXYFHa9avJdKIltNqDeG_NDKVJ5vElf2" target="_blank">View</a>
                    </div>
                    { incompleteStepsExist(props.selectedProgram?.programId)
                        ? <div className="pb-3">
                            <span className="text-danger">Previous step(s) must be completed before this step can be completed.</span>
                          </div>
                        : <></>
                    }
                </div>
                <div className="mx-5">
                    <Form>
                        <Form.Group as={Row} controlId="describe_analyze_g1" className="py-2">
                            <Form.Label column sm="4" className="p-0">
                                Department
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8">
                                    {props.department.name}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1" className="py-2">
                            <Form.Label column sm="4" className="p-0">
                                Program
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8">
                                    {props.selectedProgram?.name}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1" className="py-2">
                            <Form.Label column sm="4" className="p-0">
                                Theme
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8">
                                    {props.theme ? props.theme.name : 'Unavailable'}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1" className="py-2">
                            <Form.Label column sm="4" className="p-0">
                                Learning Outcome
                            </Form.Label>
                            <Col sm="8">
                            <Form.Select 
                                    aria-label="Select Learning Outcome"
                                    onChange={props.handleLearningOutcomeChanged}
                                    name={'program-' + props.selectedProgram?.programId + '_slo-' + props.selectedLearningOutcome?.sloId}
                                    value={props.selectedLearningOutcome?.sloId}
                                    >
                                    { props.selectedProgram &&
                                        props.learningOutcomes[props.selectedProgram.programId].map((slo, key) =>
                                            <option key={key} value={slo.sloId}>{slo.text}</option>
                                        )
                                    }
                                </Form.Select>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1" className="py-2">
                            <Form.Label column sm="4" className="p-0">
                                Focus Area
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8" className="w-100">
                                    { props.selectedProgram &&
                                        props.step1DataStore[props.selectedProgram.programId][props.selectedLearningOutcome?.sloId]?.s1q1}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1" className="py-2">
                            <Form.Label column sm="4" className="p-0">
                                Description of Tool
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8" className="w-100">
                                    {step2Data.toolDescription}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1" className="py-2">
                            <Form.Label column sm="4" className="p-0">
                                Course(s) Assessed
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8" className="w-100">
                                    {step2Data.coursesAssessed}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1" className="py-2">
                            <Form.Label column sm="4" className="p-0">
                                Hypothetical Analysis
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8" className="w-100">
                                    {step2Data.hypotheticalAnalysis}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1" className="py-2">
                            <Form.Label column sm="4" className="p-0">
                                <FastFormQuestion 
                                    text={FORM_QUESTIONS["summaryOfResults"].text}
                                    required={FORM_QUESTIONS["summaryOfResults"].required}
                                    />
                                <span className="text-muted"> 
                                    e.g: _% of students did... See background info linked 
                                    above for guidance on summarizing data
                                </span>
                            </Form.Label>
                            <Col sm="8">
                                <FastTextArea
                                    id="summaryOfResults"
                                    callback={props.onSummaryOfResultsChanged}
                                    text={props.stepData.summaryOfResults}
                                    rows="3"
                                    disabled={isFormDisabled(props.selectedProgram?.programId)}
                                    maxLength="2048"
                                    />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1" className="py-2">
                            <Form.Label column sm="4" className="p-0">
                                <FastFormQuestion 
                                    text={FORM_QUESTIONS["reflectionOnHypothesis"].text}
                                    required={FORM_QUESTIONS["reflectionOnHypothesis"].required}
                                    />
                                <span className="text-muted">
                                    Do the results support, contradict, or even relate 
                                    to original focus area question or hypothesis?
                                </span>
                            </Form.Label>
                            <Col sm="8">
                                <FastTextArea
                                    id="reflectionOnHypothesis"
                                    callback={props.onReflectionOnHypothesisChanged}
                                    text={props.stepData.reflectionOnHypothesis}
                                    rows="3"
                                    disabled={isFormDisabled(props.selectedProgram?.programId)}
                                    maxLength="2048"
                                    />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1" className="py-2">
                            <Form.Label column sm="4" className="p-0">
                                <FastFormQuestion 
                                    text={FORM_QUESTIONS["interpretationOfResults"].text}
                                    required={FORM_QUESTIONS["interpretationOfResults"].required}
                                    />
                                <span className="text-muted">
                                    e.g. This shows us that...
                                </span>
                            </Form.Label>
                            <Col sm="8">
                                <FastTextArea
                                    id="interpretationOfResults"
                                    callback={props.onInterpretationOfResultsChanged}
                                    text={props.stepData.interpretationOfResults}
                                    rows="3"
                                    disabled={isFormDisabled(props.selectedProgram?.programId)}
                                    maxLength="2048"
                                    />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1" className="py-2">
                            <Form.Label column sm="4" className="p-0">
                                <FastFormQuestion 
                                    text={FORM_QUESTIONS["followUpQuestions"].text}
                                    required={FORM_QUESTIONS["followUpQuestions"].required}
                                    />
                                <span className="text-muted">
                                    e.g. Is this related to...
                                </span>
                            </Form.Label>
                            <Col sm="8">
                                <FastTextArea
                                    id="followUpQuestions"
                                    callback={props.onFollowUpQuestionsChanged}
                                    text={props.stepData.followUpQuestions}
                                    rows="3"
                                    disabled={isFormDisabled(props.selectedProgram?.programId)}
                                    maxLength="1024"
                                    />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="describe_analyze_g1" className="py-2">
                            <Form.Label column sm="4" className="p-0">
                                <FastFormQuestion 
                                    text={FORM_QUESTIONS["actionsForImprovement"].text}
                                    required={FORM_QUESTIONS["actionsForImprovement"].required}
                                    />
                                <span className="text-muted">
                                    e.g. They might do better if we...
                                </span>
                            </Form.Label>
                            <Col sm="8">
                                <FastTextArea
                                    id="actionsForImprovement"
                                    callback={props.onActionsForImprovementChanged}
                                    text={props.stepData.actionsForImprovement}
                                    rows="3"
                                    disabled={isFormDisabled(props.selectedProgram?.programId)}
                                    maxLength="1024"
                                    />
                            </Col>
                        </Form.Group>
                    </Form>
                    <div className="text-center">
                        <span className="pe-1 text-danger fw-bold">*</span>
                        <span>Indicates required fields</span>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer style={{ display: "flex", justifyContent: "center"}}>
                <Button
                    variant="secondary"
                    onClick={handleCancel}
                    className="p-25"
                    >
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={handleClose}
                    className="p-25"
                    >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}